import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (phone, password) => {
    try {
      const { data } = await api.post("/auth/login", { phone, password });
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
      }
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatError(e) };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.access_token) {
        localStorage.setItem("access_token", data.access_token);
      }
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatError(e) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // abaikan
    } finally {
      localStorage.removeItem("access_token");
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);